import { Box } from "atoms/grid";
import { appUserSelectNone } from "lib/app/styles";
import { colors, fonts, weights } from "lib/theme";
import React from "react";
import styled, { css } from "styled-components";
import {
  color,
  display,
  fontSize,
  fontWeight,
  lineHeight,
  space,
  textAlign,
  width,
} from "styled-system";

/**
 * Headings
 */

const headerStyles = css`
  ${appUserSelectNone}
  margin: 0;
  // sanitize.css has changed line height to a more sensible default
  // Keep the (not great) old version until we have better headers
  line-height: 1.15;
  ${space};
  ${textAlign};
  ${fontSize};
  color: ${colors.navy[500]};
  ${color};
  ${display};
`;

/** @deprecated please update with /atoms/typography.tsx */
export const H1 = styled.h1`
  ${headerStyles}
  font-weight: ${weights.bold};
`;
H1.defaultProps = {
  fontSize: [28, 36],
  color: colors.navy[500],
};

/** @deprecated please update with /atoms/typography.tsx */
export const H2 = styled.h2`
  ${headerStyles}
  font-weight: ${weights.regular};
  color: ${colors.navy[500]};
`;
H2.defaultProps = {
  fontSize: [24, 30],
};

/** @deprecated please update with /atoms/typography.tsx */
export const H3 = styled.h3`
  ${headerStyles}
`;
H3.defaultProps = {
  fontSize: [20, 24],
};

/** @deprecated please update with /atoms/typography.tsx */
export const H4 = styled.h4`
  ${headerStyles}
  font-weight: ${weights.regular};
`;
H4.defaultProps = {
  fontSize: [18, 22],
};

/** @deprecated please update with /atoms/typography.tsx */
export const H4Bold = styled(H4)`
  font-weight: ${weights.bold};
`;

/** @deprecated please update with /atoms/typography.tsx */
export const H5 = styled.h5`
  ${headerStyles}
  ${fontWeight}
  color: ${colors.navy[500]};
`;
H5.defaultProps = {
  fontSize: [16, 18],
  fontWeight: weights.regular,
};

/** @deprecated please update with /atoms/typography.tsx */
export const H5SemiBold = styled(H5)`
  font-weight: ${weights.semibold};
`;

/**
 * Colors
 */
/** @deprecated please update with /atoms/typography.tsx */
export const Pink = styled.span`
  color: ${colors.pink[500]};
`;

/** @deprecated please update with /atoms/typography.tsx */
export const Blue = styled.span`
  color: ${colors.blue};
`;

/** @deprecated please update with /atoms/typography.tsx */
export const Green = styled.span`
  color: ${colors.teal[400]};
`;

/**
 * Body typography
 */

/** @deprecated please update with /atoms/typography.tsx */
export const P = styled(Box)`
  ${headerStyles};
  line-height: 24px;
  ${lineHeight}
  ${textAlign};
  ${fontWeight}

  ${(p) =>
    p.monospace &&
    `
    font-family: ${fonts.mono};
    letter-spacing: 0.8px;
    font-weight: 600;
    font-size: 18px;
  `}
`;
P.defaultProps = {
  as: "p",
  m: 0,
  fontSize: 16,
  fontWeight: weights.regular,
};

/** @deprecated please update with /atoms/typography.tsx */
export const PSmall = styled(P)`
  line-height: 18px;
`;
PSmall.defaultProps = {
  fontSize: "12px",
  as: "p",
  // To match P's 24px line height
  p: "3px 0",
};

/** @deprecated please update with /atoms/typography.tsx */
export const PSmallBold = styled(PSmall)`
  font-weight: ${weights.bold};
`;

/** @deprecated please update with /atoms/typography.tsx */
export const PLarge = styled(P)`
  line-height: 1.4;
`;
PLarge.defaultProps = {
  as: "p",
  fontSize: [16, , 18, 22],
};

/** @deprecated please update with /atoms/typography.tsx */
export const Em = styled.em`
  ${space};
  font-style: normal;
  color: ${colors.teal[400]};
`;

/** @deprecated please update with /atoms/typography.tsx */
export const Strong = styled.strong`
  ${space};

  font-weight: ${weights.bold};
`;
Strong.defaultProps = {
  color: colors.navy[500],
};

/** @deprecated please update with /atoms/typography.tsx */
export const A = styled.a`
  ${space};
  ${color};
  ${fontWeight};
`;
A.defaultProps = {
  color: colors.pink[500],
  fontWeight: "medium",
};

/** @deprecated please update with /atoms/typography.tsx */
export const UnstyledA = styled.a`
  ${space};
  ${color}
  ${display}
  ${width}
  ${fontWeight}
  ${textAlign}

  text-decoration: none;
`;
UnstyledA.defaultProps = {
  color: "inherit",
  display: "inline-block",
};

/** @deprecated please update with /atoms/typography.tsx */
export const CenteredContentUnstyledA = React.forwardRef((props, ref) => (
  <Box
    mr={16}
    display="flex"
    alignItems="center"
    height="100%"
    ref={ref}
    {...props}
    as={UnstyledA}
  />
));

/** @deprecated please update with /atoms/typography.tsx */
export const Hr = styled.hr`
  margin: 0;
  ${space};

  border: 0;
  height: 0;
  border-top: 1px solid ${colors.gray[500]};
`;

/** @deprecated please update with /atoms/typography.tsx */
export const Ul = styled.ul`
  ${space};
  font-style: normal;
`;
Ul.defaultProps = {
  pl: "1em",
};

/** @deprecated please update with /atoms/typography.tsx */
export const Ol = styled.ol`
  ${space};
  font-style: normal;
`;
Ol.defaultProps = {
  pl: "1em",
};

/** @deprecated please update with /atoms/typography.tsx */
export const Li = styled.li`
  ${space};
  font-style: normal;
`;
Li.defaultProps = {
  mb: 10,
};
